module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-01-941fcd47d4187f99c30b6253109e185d.jpg";